import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Spinner } from "@/components/ui";
import { useJoinWorkspace } from "@/lib/api/queries";
import { useWorkspaceStore } from "@/stores/workspace";

export default function JoinPage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const join = useJoinWorkspace();
  const setWorkspaceId = useWorkspaceStore((s) => s.setWorkspaceId);

  useEffect(() => {
    if (!code) return;
    join.mutate(code, {
      onSuccess: (workspace) => {
        setWorkspaceId(workspace.id);
        toast.success(`${workspace.name}에 합류했어요`);
        navigate("/", { replace: true });
      },
      onError: () => {
        toast.error("초대 링크가 올바르지 않아요");
        navigate("/", { replace: true });
      },
    });
    // 코드가 바뀔 때만 재실행한다. join/navigate/setWorkspaceId를 deps에 넣으면
    // 매 렌더마다 재실행돼 합류 요청이 중복 발송된다.
  }, [code]);

  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Spinner />
    </div>
  );
}
